import { AvatarSize } from '../Avatar.types';

export const getAvatarSizeInPx = (size?: AvatarSize): number => {
  if (typeof size === 'number') {
    return size;
  }
  switch (size) {
    case 'xs':
      return 24;
    case 's':
    case undefined:
      return 40;
    case 'm':
      return 55;
    case 'l':
      return 80;
    case 'xl':
      return 160;
  }
};

// This function tries to convert letters to numbers to set always the same colors for the same user.
export const getStringAvatarColor = (stringAvatarUid?: string): string => {
  if (!stringAvatarUid) return avatarColors['0'];
  // convert letters to numbers. it will return ascii numbers for letters. 'a' === 097
  const numbers = stringAvatarUid?.split('').map((letter) => letter.toLocaleLowerCase().charCodeAt(0));
  let sum = 0;
  // sum numbers
  numbers.forEach((number) => {
    sum += number;
  });
  // Get the last digit. For example: 156 will return "6"
  const stringifySum = sum.toString();
  const digit = stringifySum[stringifySum.length - 1] as keyof typeof avatarColors;
  return digit ? avatarColors[`${digit}`] : avatarColors['0'];
};

// note: Colors were picked from design table available in the figma
// https://www.figma.com/file/nAL2DixlY5bOnuWRVeWK6Y/Design-Tokens?node-id=1203%3A2564&t=GUjAsXVxHBgmaArf-0
export const avatarColors = {
  '0': '#006494',
  '1': '#006977',
  '2': '#4355B9',
  '3': '#006E29',
  '4': '#5A6400',
  '5': '#8A4E00',
  '6': '#BD180C',
  '7': '#7043BF',
  '8': '#9A25AE',
  '9': '#BC003F'
};
